import { rgba } from '@vimeo/bokeh-utils';

const Popover = {
  parts: ["content", "popper"],
  baseStyle: {
    content: {
      minWidth: "10rem",
      minHeight: "2rem",
      maxWidth: "40rem",
      bgColor: "white",
      borderRadius: "popoverContent",
      padding: "sm",
      _light: {
        boxShadow: "0 0 1px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.15)"
      },
      _dark: {
        bgColor: "grayscale.900",
        borderWidth: "1px",
        borderColor: rgba("white", 0.125)
      }
    },
    popper: {
      zIndex: "docked"
    }
  }
};

export { Popover };
